export enum PromotedState {
  None = 'None',
  Active = 'Active',
  Finished = 'Finished',
}
